/**
 * Navigation visibility flags.
 *
 * These hide an entry from the UI surfaces (sidebar, command palette, keyboard
 * mnemonic). They do NOT delete the page, remove the route, or touch any data —
 * a hidden route is still reachable by direct URL and still enforces its own
 * permission check. Anything relying on a nav entry being absent for security
 * would be relying on the wrong thing.
 *
 * Flags are read from NEXT_PUBLIC_* env vars so the SAME build source can be
 * configured differently per deployment — the algo desk and the manual trade
 * terminal are separate installs with separate operators and separate needs.
 * Forking the code per box would mean two branches to keep in step forever.
 */

/**
 * Audit log (`/admin/audit`).
 *
 * VISIBLE BY DEFAULT — hiding an audit trail should be a deliberate, per-install
 * decision, never something a deploy inherits by accident. Set
 * `NEXT_PUBLIC_SHOW_AUDIT_LOG=0` in that install's .env.production to hide it.
 *
 * Hidden on the algo desk (algo-terminal) at the operator's request 2026-08-26.
 * Visible on the manual trade terminal.
 *
 * Note: NEXT_PUBLIC_* is inlined at BUILD time, so changing it requires a
 * rebuild of that install, not just a restart.
 */
export const SHOW_AUDIT_LOG = process.env.NEXT_PUBLIC_SHOW_AUDIT_LOG !== '0';
